import React from 'react';
import PropTypes from 'prop-types';

import { Container } from 'components/TagStyles';

const Tag = ({ children, bg, textColor, radius }) => (
  <Container bg={bg} textColor={textColor} radius={radius}>
    {children}
  </Container>
);

Tag.defaultProps = {
  bg: null,
  textColor: null,
  radius: null,
};

Tag.propTypes = {
  children: PropTypes.string.isRequired,
  bg: PropTypes.func,
  textColor: PropTypes.func,
  radius: PropTypes.number,
};

export default Tag;
